import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DataTable } from '@/Components/DataTable/DataTable';
import { DocumentTemplateRow } from '@/Types';
import { useDocumentPrintTableColumnInfo } from './ColumnInfo';
import { documentPrintModalActions } from '../../services/reducer';
import { documentPrintModalSelectors } from '../../services/selectors';

export function SelectTemplateTableComponent(): React.ReactElement {
  const dispatch = useDispatch();

  const columnInfos = useDocumentPrintTableColumnInfo();
  const documentTemplates = useSelector(documentPrintModalSelectors.documentTemplates);

  return (
    <DataTable<DocumentTemplateRow>
      rows={documentTemplates}
      rowKey={'guid'}
      columnInfos={columnInfos}
      filterOptions={{
        needShowFiltersButton: false,
        needHeaderFilter: false,
        needColumnChooser: false,
        showFilterBuilder: false,
        needGlobalSearchPanel: false,
        needClearFiltersButton: false,
      }}
      editOptions={{
        needEditing: false,
      }}
      selectOptions={{
        selectMode: 'single',
        onFocusedRowChanged: (data) => {
          if (data) {
            dispatch(documentPrintModalActions.setDocumentType(data?.numberGenerationType));
            dispatch(documentPrintModalActions.setSelectedTemplate(data));
          }
        },
      }}
      defaultOptions={{
        showPagination: false,
      }}
      exportOptions={{
        needExport: false,
        exportFileName: '',
      }}
    />
  );
}

export const SelectTemplateTable = React.memo(SelectTemplateTableComponent);
